import { render, staticRenderFns } from "./CommonTab.vue?vue&type=template&id=1a2b2786"
import script from "./CommonTab.vue?vue&type=script&lang=ts"
export * from "./CommonTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports